import React from "react";
export default class RecordRightInfo extends React.Component<any, any>{

    render() {
        const { RecordRight } = this.props.entity;
        const properties = Object.entries(RecordRight).filter(([key, value]) => !key.endsWith("Reason") && value === false && RecordRight[key + "DeniedReason"]);
        properties.sort((a, b) => a[0].localeCompare(b[0]));

        return (
            <div style={{ margin: "5px" }}>
                {properties.map(([key, value]) => (
                    <React.Fragment key={key}>
                        <div>
                            <span style={{ fontWeight: "bold" }}>{key}:</span>
                            <br/>
                            <span style={{ wordBreak: "break-word" }}>{RecordRight[key + "DeniedReason"]}</span>
                        </div>
                        <br />
                    </React.Fragment>
                ))}
            </div>
        );
    }
};